import { Box, FormLabel, type FormLabelProps } from "@chakra-ui/react";
import { type ReactNode } from "react";
import { FiInfo } from "react-icons/fi";
import { ExplainedIcon } from "../support/ExplainedIcon/ExplainedIcon";

interface FormLabelWithInfoProps extends FormLabelProps {
  tooltip?: string | null;
  suffix?: ReactNode;
}

export const FormLabelWithInfo = ({ tooltip, suffix, children, ...props }: FormLabelWithInfoProps) => (
  <FormLabel {...props}>
    {children}
    {tooltip && (
      <Box as="span" ml="2" display="inline-flex" verticalAlign="middle">
        <ExplainedIcon explanation={tooltip} icon={FiInfo} color="smMuted" />
      </Box>
    )}
    {suffix}
  </FormLabel>
);
